import { IState } from 'legacy/lut/store'
import { listenerMiddleware } from 'legacy/lut/store/middlewares/listenerMiddleware'

import {
  refreshContractSignatureProgressData,
  refreshLRProgressData,
  refreshProfilingProgressData,
} from '../actions/refreshProgressData'
import { progressApi } from '../api/progressApi'

listenerMiddleware.startListening({
  actionCreator: refreshProfilingProgressData,
  effect: async (_action, listenerEffectAPI) => {
    const { dispatch, getState } = listenerEffectAPI
    const state = getState() as IState

    const requestId = state.onboarding.requestData.data.EntryId
    const partnerId = state.onboarding.progressData.profilingProgressData.meta?.arg?.['partnerId']
    if (partnerId && requestId) {
      dispatch(progressApi.getProfilingProgress({ partnerId, requestId }))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: refreshLRProgressData,
  effect: async (_action, listenerEffectAPI) => {
    const { dispatch, getState } = listenerEffectAPI
    const state = getState() as IState

    const requestId = state.onboarding.progressData.lrProgressData.meta?.arg?.['requestId']
    if (requestId) {
      dispatch(progressApi.getLRProgress({ requestId }))
    }
  },
})

listenerMiddleware.startListening({
  actionCreator: refreshContractSignatureProgressData,
  effect: async (_action, listenerEffectAPI) => {
    const { dispatch, getState } = listenerEffectAPI
    const state = getState() as IState

    const requestId =
      state.onboarding.progressData.contractSignatureProgressData.meta?.arg?.['requestId']

    if (requestId) {
      dispatch(progressApi.getContractSignatureProgress({ requestId }))
    }
  },
})
